const FormLabel = {
  baseStyle: {},
  sizes: {},
  variants: {
    "desktop-button-bold": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "700",
      fontSize: "18px",
      lineHeight: "24px",
    },
    "form-label-bold": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "18px",
      lineHeight: "27px",
    },
    "mobile-form-label-bold": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "600",
      fontSize: "14px",
      lineHeight: "21px",
    },
    "mobile-button-bold": {
      fontFamily: "Inter",
      fontStyle: "normal",
      fontWeight: "700",
      fontSize: "14px",
      lineHeight: "28px",
    },
  },
};

export default FormLabel;
